import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { AW_MODEL_MANAGEMENT_API_URL } from './Constants';

interface Settings extends AGraphApiSettings {
  getConfigurationDirectoryFn?: () => string | undefined;
  getPkgFn?: () => string | undefined;
}

export const awModelManagementSettings: Settings = {
  getPkgFn: undefined,
  getAladdinApiKey: undefined,
  getConfigurationDirectoryFn: undefined,
  getEnvTypeFn: undefined,
};

export const awModelManagementApi = axios.create({
  timeout: API_TIMEOUT,
});

awModelManagementApi.interceptors.request.use((config) => {
  const { getPkgFn, getConfigurationDirectoryFn, getAladdinApiKey, getEnvTypeFn } = awModelManagementSettings;
  if (!getPkgFn) {
    throw Error('You must define a function for awModelManagementSettings.getPkgFn before using this API');
  }
  const configurationDirectory = getConfigurationDirectoryFn?.();
  const baseURL = AW_MODEL_MANAGEMENT_API_URL;
  const pkg = config.params?.pkg ?? getPkgFn?.();

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    params: {
      ...config.params,
      pkg,
      configurationDirectory,
    },
  };

  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), getEnvTypeFn?.());

  return updatedConfig;
});
